import LocalOfferTwoToneIcon from "@mui/icons-material/LocalOfferTwoTone";
import PlaceIcon from "@mui/icons-material/Place";
import { Box, Card, Slider, styled, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import { MemoizedButton } from "../../SDK/button";
import { sendAnalytics } from "../../utils/analyticsCommon";
import { createCookieInHour } from "../../utils/cookie";
import { pmt } from "../../utils/emiCalculation";
import { leadActions } from "../../utils/leadActions";
import TenureRadioButton from "./tenureRadioButtons";

const EmiScreenStyle = styled(Box)(({ theme }) => ({
  marginTop: "8px",

  ".textHeadingStyle": {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    color: primary.mainText,
    margin: "12px 0px",
  },

  ".loanTextStyle": {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "30px",
    color: primary.mainText,
  },
  ".discountValStyle": {
    backgroundColor: primary.main,
    borderRadius: "2px",

    fontWeight: "700",
    fontSize: "10px",
    color: primary.white,

    textAlign: "center",
    height: "20px",
    width: "100%",
    padding: "4px",
    marginTop: "8px",
    marginRight: "4px",
  },
  ".discountAmtStyle": {
    fontWeight: "700",
    fontSize: "22px",
    //lineHeight: "39px",
    color: primary.mainText,
    margin: "0 2px",
  },
  ".loanAmtStyle": {
    fontWeight: "700",
    fontSize: "14px",
    // lineHeight: "16px",
    color: "#8E8D8F",
    margin: "0 4px",
    textAlign: "right",
  },

  ".downpaymentTextStyle": {
    fontWeight: "700",
    fontSize: "12px",
    //lineHeight: "18px",
    color: primary.mainText,
    margin: "4px",
  },
  ".downpaymentAmtStyle": {
    fontWeight: "700",
    fontSize: "24px",
    //lineHeight: "42px",
    color: primary.mainText,
    margin: "4px",
  },
  ".minDownpaymentAmtStyle": {
    fontWeight: "600",
    fontSize: "12px",

    color: primary.greyText,
    marginLeft: "4px",
  },
  ".tenure": {
    fontWeight: "600",
    fontSize: "12px",
    //lineHeight: "18px",
    color: primary.mainText,
  },
}));

const EMICalulator = ({ loanAmount, vehicleData }) => {
  const state = useContext(Context);

  const { showFormPopup, showStatePopup, updateEmiPriceValue } =
    useContext(Context);

  const discountPercentage = 10.5;
  // const loanAmount = 350000;
  // Discount of 10%

  const minDownpayment = 50000;
  // const discountAmount = loanAmount - (loanAmount * discountPercentage) / 100;
  //const discountAmount = loanAmount - minDownpayment;

  const discountedAmt = loanAmount - minDownpayment;

  const [duration, setDuration] = React.useState(36);
  const [calculatedEMI, setCalculateEMI] = React.useState();
  const [downpaymentAmount, setDownpaymentAmount] = React.useState(50000);

  const [offerEmi, setOfferEmi] = useState();

  const handleState = () => {
    showStatePopup("false");
  };

  let rate = 0.2201 / 12; // Monthly interest rate
  let offerRate = 0.1875 / 12;
  let term = 36; // Term in months

  const handleSubmit = (e) => {
    let amount = loanAmount - (e?.target?.value ?? 50000);

    let emi = Math.ceil(pmt(rate, term, amount));
    // let emi = parseInt(
    //   amount *
    //     rate *
    //     (Math.pow(1 + rate, term) / (Math.pow(1 + rate, term) - 1))
    // );

    let offerEmi = Math.ceil(pmt(offerRate, term, amount));

    // let offerEmi = parseInt(
    //   amount *
    //     offerRate *
    //     (Math.pow(1 + offerRate, term) / (Math.pow(1 + offerRate, term) - 1))
    // );

    setOfferEmi(offerEmi);
    setCalculateEMI(emi);
    updateEmiPriceValue(offerEmi);
  };

  useEffect(() => {
    var e;
    handleSubmit(e);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.selectedState, vehicleData]);

  return (
    <EmiScreenStyle>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          style={{
            fontSize: "20px",

            margin: "8px",
            display: "flex",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: "bold",
          }}
          onClick={() => {
            handleState();
            leadActions("CLICK_SAVINGS_ESTIMATION");
            sendAnalytics("state_change_by_emi", {}, "en");
          }}
        >
          Calculate Your EMI{" "}
          <PlaceIcon style={{ marginLeft: "16px", color: primary.secondary }} />
          <span style={{ color: primary.secondary }}>
            {state?.selectedState}
          </span>
        </Typography>
      </Box>

      <Card>
        <Box
          style={{ background: primary.secondaryGreen, padding: "0px 12px" }}
        >
          <Box
            sx={{
              padding: "12px",
              borderBottom: `1px solid ${primary.greyText}`,
            }}
          >
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography fontSize={"12px"}>Full Price</Typography>

              <Box style={{ display: "flex" }} fontSize={"12px"}>
                {/* <Typography className="discountValStyle">
                {discountPercentage} % OFF
              </Typography> */}
                <Typography>₹{loanAmount}</Typography>
              </Box>
            </Box>

            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography fontSize={"12px"}>Downpayment</Typography>

              <Box style={{ display: "flex" }}>
                <Typography fontSize={"12px"}>
                  - ₹{downpaymentAmount}
                </Typography>
              </Box>
            </Box>

            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                className="loanTextStyle"
                style={{ fontWeight: "bold" }}
              >
                Loan Amount
              </Typography>

              <Box style={{ display: "flex", borderTop: "1px solid grey" }}>
                {/* <Typography className="discountValStyle">
                {discountPercentage} % OFF
              </Typography> */}
                <Typography style={{ fontWeight: "bold" }}>
                  ₹{loanAmount - downpaymentAmount}
                </Typography>
              </Box>
            </Box>

            {/* <Typography className="loanAmtStyle">
              <del>₹{loanAmount}</del>
            </Typography> */}
          </Box>
          <Typography className="downpaymentTextStyle">
            Downpayment{" "}
            <span style={{ fontSize: "10px", color: primary.greyText }}>
              {" "}
              (Min ₹{minDownpayment})
            </span>
          </Typography>
          <Typography className="downpaymentAmtStyle">
            ₹{downpaymentAmount}
          </Typography>

          <Box
            sx={{
              margin: "0px 10px",
            }}
          >
            <Slider
              sx={{ color: primary.main, height: "8px", margin: "0px" }}
              defaultValue={downpaymentAmount}
              max={loanAmount}
              min={50000}
              step={1000}
              disableSwap={downpaymentAmount < 50000}
              onChange={(e, value) => {
                const payload = {
                  previousValue: downpaymentAmount,
                  selectedValue: value,
                };
                sendAnalytics("emi_downpayment_input_switched", payload, "en");
                setDownpaymentAmount(value);
                leadActions("CLICK_SAVINGS_ESTIMATION");
                handleSubmit(e);

                if (e.target.value >= 50000) {
                  setDownpaymentAmount(value);
                  handleSubmit(e);
                }
              }}
            />
          </Box>

          {/* <Typography className="minDownpaymentAmtStyle">
            Min ₹{minDownpayment}
          </Typography> */}

          <TenureRadioButton handleDuration={36} handleSubmit={handleSubmit} />

          <Box
            sx={{ mt: 0.5, pb: 0.5 }}
            display="flex"
            justifyContent="space-between"
          >
            <Typography className="downpaymentTextStyle">
              Standard EMI
            </Typography>
            {calculatedEMI > 0 && (
              <Box textAlign={"center"}>
                <Typography
                  style={{
                    color: primary.greyText,
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  <del> ₹{calculatedEMI} pm </del>
                </Typography>
                <Typography
                  style={{
                    color: primary.greyText,
                    fontSize: "9px",
                    fontWeight: "bold",
                  }}
                >
                  Interest rate :{" "}
                  <del>
                    {" "}
                    <span style={{ fontSize: "14px" }}>13.74 %</span>
                  </del>
                </Typography>
              </Box>
            )}
          </Box>
        </Box>

        <Box style={{ background: primary.secondary }}>
          <Box
            style={{
              background: primary.lightYellowBg,
              padding: "16px",
              borderRadius: "0px 0px 8px 8px",
              alignItems: "center",
              border: `1px solid ${primary.mainGreen}`,
            }}
          >
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <Typography
                className="loanTextStyle"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                OFFER EMI
              </Typography>

              <Typography className="discountAmtStyle">
                ₹{offerEmi} pm
              </Typography>

              {/* <Box style={{ display: "flex" }}>
            <Typography className="discountValStyle">
              {discountPercentage} % OFF
            </Typography>
            <Typography className="discountAmtStyle">₹{offerEmi} pm</Typography>
          </Box> */}
            </Box>

            <Typography>
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                OFFER{" "}
              </span>
              <span>Interest rate : </span>
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: primary.main,
                }}
              >
                12.49%{" "}
              </span>
            </Typography>
          </Box>

          <Box
            style={{
              padding: "4px",
              background: primary.secondary,
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Typography
              style={{
                color: primary.electricGreen,
                fontWeight: 700,
                fontSize: "11px",
                color: primary.white,
                lineHeight: "14px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <LocalOfferTwoToneIcon
                style={{ height: "14px", color: primary.electricGreen }}
              />
              Get Upto{" "}
              <span
                style={{
                  color: primary.electricGreen,
                  fontWeight: 700,
                  fontSize: "12px",
                  padding: "0px 4px",
                }}
              >
                {" "}
                ₹5000{" "}
              </span>{" "}
              Discount on all Electric Vehicles
            </Typography>
            {/* <Typography
              style={{
                color: primary.electricGreen,
                fontWeight: 700,
                fontSize: "9px",
                color: primary.white,
                lineHeight: "14px",
              }}
            >
              Pay ₹499 (Refundable) to Avail the Limited period offer
            </Typography> */}
          </Box>
        </Box>
      </Card>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "12px",
        }}
      >
        <MemoizedButton
          sx={{
            background: "primary.main",
            boxShadow: "none",
            border: "none",
            borderRadius: "7px",
            paddingLeft: "20px",
            paddingRight: "20px",
            width: "100%",
          }}
          content={"Book Now"}
          onClick={() => {
            let payload = {
              vehicle_name: vehicleData?.name,
              vehicle_id: vehicleData?.vehicle_id,
              booking_price_shown: vehicleData?.price,
              emi_shown: vehicleData?.emiPrice,
              button_name: "EMI book vehicle ",
            };
            leadActions("CLICK_SAVINGS_ESTIMATION");

            createCookieInHour("lead_trigger", "book_by_emi_calculator", 10);
            sendAnalytics("emi_book_now_button_clicked", payload, "en");
            showFormPopup("Book Vehicle");
          }}
        />
      </Box>
    </EmiScreenStyle>
  );
};

export default EMICalulator;
